import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { ProductCard } from "../ProductCard";
import { Reveal } from "../Reveal";
import { products } from "../../data/products";
const tabs = [{
  id: "all",
  label: "Best sellers"
}, {
  id: "him",
  label: "For him"
}, {
  id: "her",
  label: "For her"
}, {
  id: "couples",
  label: "For couples"
}] as const;
type TabId = (typeof tabs)[number]["id"];
const ease = [0.23, 1, 0.32, 1] as const;
export function BestSellers() {
  const [active, setActive] = useState<TabId>("all");
  const visible = (active === "all" ? products : products.filter(p => p.category === active)).slice(0, 8);
  return <section className="bg-night pb-20 lg:pb-28" aria-labelledby="bestsellers-title" data-id="element-154" data-mp="i7aozso16paz">
      <div className="mx-auto max-w-7xl px-6" data-id="element-155" data-mp="1xnropn9d8bct">
        <Reveal className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-156" data-mp="1tkuzhdpblgzw">
          <div data-id="element-157" data-mp="2dz03ep2nicrw">
            <h2 id="bestsellers-title" className="font-display text-4xl font-extrabold tracking-tight sm:text-5xl" data-id="element-158" data-mp="2dxf990k90vuk">
              Hot &amp; happening
            </h2>
            <p className="mt-3 text-muted" data-id="element-159" data-mp="2mzeqntz6e1y1">The products our customers keep coming back for.</p>
          </div>
          <div role="tablist" aria-label="Filter products" className="no-scrollbar -mx-6 flex gap-1 overflow-x-auto px-6 md:mx-0 md:rounded-full md:border md:border-line md:p-1" data-id="element-160" data-mp="2ryrof9rl4tfe">
            {tabs.map(tab => {
            const selected = tab.id === active;
            return <button key={tab.id} role="tab" type="button" aria-selected={selected} onClick={() => setActive(tab.id)} className={`relative whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-200 ${selected ? "text-night" : "text-muted hover:text-white"}`} data-id="element-161" data-mp="247445aotwgm3">
                  {selected && <motion.span layoutId="bestseller-tab" className="absolute inset-0 rounded-full bg-brand" transition={{
                type: "spring",
                bounce: 0.15,
                duration: 0.35
              }} data-id="element-162" data-mp="2eue0aac54k2l" />}
                  <span className="relative" data-id="element-163" data-mp="20w5v5f4yacgc">{tab.label}</span>
                </button>;
          })}
          </div>
        </Reveal>

        <motion.div layout role="tabpanel" className="mt-10 grid grid-cols-2 gap-x-4 gap-y-10 sm:gap-x-5 lg:grid-cols-4" data-id="element-164" data-mp="1vye4spjyeye9">
          <AnimatePresence mode="popLayout" initial={false} data-id="element-165" data-mp="24vy8041dn4ri">
            {visible.map((product, i) => <motion.div key={product.slug} layout initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.3,
              delay: Math.min(i, 6) * 0.04,
              ease
            }
          }} exit={{
            opacity: 0,
            scale: 0.96,
            transition: {
              duration: 0.15
            }
          }} className="flex" data-id="element-166" data-mp="3l9elbkzmnhue" data-mpi={i}>
                <div className="flex w-full flex-col" data-id="element-167" data-mp="3evr7dmr84h7b">
                  <ProductCard product={product} data-id="element-168" data-mp="3ex279bhjt4t5" />
                </div>
              </motion.div>)}
          </AnimatePresence>
        </motion.div>

        <div className="mt-14 flex justify-center" data-id="element-169" data-mp="bfbsdssc3mpg">
          <Link to="/shop" className="group inline-flex items-center gap-2 rounded-full border border-line px-7 py-3.5 text-sm font-semibold transition-colors hover:border-brand hover:bg-brand hover:text-night" data-id="element-170" data-mp="gcu2hmi387z1">
            View all {products.length} products
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-171" data-mp="ud4tcpjedmk7" />
          </Link>
        </div>
      </div>
    </section>;
}